﻿import './styles/tokens.css';
import './styles/app.css';
import { QuickFitBattleApp } from './app';

const root = document.getElementById('app');

if (!root) {
  throw new Error('Missing #app root');
}

const app = new QuickFitBattleApp(root);
app.mount();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Reminder notifications gracefully fall back to the page Notification API.
    });
  });
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.destroy());
}
